import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import { notPcViewStyle, pcViewStyle } from 'Src/me/pages/guest/proposals/new/React/viewByDevice';
import type { ContractorSearchInterfacePropsType } from '../..';
import { MagnifyingGlassWithCheckSvg } from './assets/MagnifyingGlassWithCheck.svg';
import { MainvisualFreeWordSearchWidget } from '../MainvisualFreeWordSearchWidget';
import { MainvisualConstructionCategorySearchWidget } from '../MainvisualConstructionCategorySearchWidget';

import HousePcPngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_mainvisual_pc.png'
import HouseMobilePngPath from 'Images/me/pages/guest/proposals/new/contractor_search_interface_mainvisual_mobile.png'

const { tablet, mobile } = mediaQueries();

export type MainvisualPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const Mainvisual = (props: MainvisualPropsType) => {
  return (
    <div
      css={css`
        background: #05141b url(${HousePcPngPath}) no-repeat center center / auto 100%;

        ${tablet(() => css`
          background: url(${HouseMobilePngPath}) no-repeat center center / cover;
        `)}
      `}
    >
      <div
        css={css`
          max-width: 1000px;
          height: 512px;
          margin-inline: auto;
          position: relative;

          ${tablet(({ setAutomaticDesignBasedSize }) => css`
            height: ${setAutomaticDesignBasedSize(750, 586)};
            padding: 0 1em;
          `)}

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            height: ${setAutomaticDesignBasedSize(750, 586)};
          `)}
        `}
      >
        <div
          css={css`
            max-width: 562px;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;

            ${tablet(({ setAutomaticDesignBasedSize }) => css`
              display: block;
              max-width: none;
              padding-top: ${setAutomaticDesignBasedSize(30, 15)};
            `)}

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              padding-top: ${setAutomaticDesignBasedSize(30, 15)};
            `)}
          `}
        >
          <div
            css={css`
              color: #fff;
              font-size: 36px;
              font-weight: bold;
              margin-bottom: 50px;

              ${tablet(({ setAutomaticDesignBasedSize }) => css`
                font-size: ${setAutomaticDesignBasedSize(36, 17)};
                text-align: center;
                margin-bottom: 30px;
              `)}

              ${mobile(({ setAutomaticDesignBasedSize }) => css`
                font-size: ${setAutomaticDesignBasedSize(36, 17)};
                margin-bottom: ${setAutomaticDesignBasedSize(30, 26)};
              `)}
            `}
          >
            <p
              css={css`
                margin-bottom: 12px;

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  margin-bottom: ${setAutomaticDesignBasedSize(12, 6)};
                `)}
              `}
            >
              あなたの街の塗装業者を
            </p>
            <div
              css={css`
                font-size: 72px;
                line-height: 1.25;

                ${tablet(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(72, 28)};
                `)}

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(72, 28)};
                `)}
              `}
            >
              <p
                css={css`
                  ${tablet(() => css`
                    display: inline-block;
                  `)}
                `}
              >
                素早くまとめて
              </p>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  gap: 0 24px;

                  ${tablet(() => css`
                    display: inline-block;
                  `)}
                `}
              >
                <p
                  css={css`
                    color: #bae8e8;

                    ${tablet(() => css`
                      display: inline-block;
                    `)}
                  `}
                >
                  検索
                </p>
                <div
                  css={css`
                    height: 1em;

                    ${pcViewStyle}

                    svg {
                      width: auto;
                      height: 100%;
                    }
                  `}
                >
                  <MagnifyingGlassWithCheckSvg />
                </div>
              </div>
              <div
                css={css`
                  padding-top: 10px;

                  ${notPcViewStyle}
                `}
              >
                <div
                  css={css`
                    font-size: 0;
                    width: 90px;
                    margin-inline: auto;

                    ${tablet(({ setAutomaticDesignBasedSize }) => css`
                      width: ${setAutomaticDesignBasedSize(90, 52)};
                    `)}

                    ${mobile(({ setAutomaticDesignBasedSize }) => css`
                      width: ${setAutomaticDesignBasedSize(90, 52)};
                    `)}
                  `}
                >
                  <MagnifyingGlassWithCheckSvg />
                </div>
              </div>
            </div>
          </div>
          <div
            css={css`
              margin-bottom: 60px;

              ${tablet(() => css`
              margin-bottom: 0;
              `)}
            `}
          >
            <MainvisualFreeWordSearchWidget {...props} />
          </div>
          <div
            css={css`
              ${pcViewStyle}

              color: #fff;
              font-size: 13px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 2px 1em;
              border: 1px solid #fff;
              border-radius: 8px;
            `}
          >
            <div
              css={css`
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0 1em;
                margin-right: 1em;
                padding-right: 1em;
                position: relative;

                &::before {
                  content: "";
                  width: 1px;
                  height: 110%;
                  background-color: #ababab;
                  border-radius: 8px;
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translateY(-50%);
                }
              `}
            >
              <p
                css={css`
                  padding-top: 2px;
                `}
              >
                ヌリカエ対応エリア
              </p>
              <p
                css={css`
                  font-size: 16px;
                  font-weight: bold;
                `}
              >
                全国47都道府県
              </p>
            </div>
            <div
              css={css`
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0 1em;
              `}
            >
              <p
                css={css`
                  padding-top: 3px;
                `}
              >
                ヌリカエ登録企業数
              </p>
              <p
                css={css`
                  font-size: 15px;
                  font-weight: bold;
                `}
              >
                全国
                <span
                  css={css`
                    font-size: 20px;
                  `}
                >
                  4,500
                </span>
                社
              </p>
            </div>
          </div>
        </div>
        <div
          css={css`
            position: absolute;
            bottom: -54px;
            right: 16px;
            z-index: 1;

            ${tablet(() => css`
              width: 100vw;
              max-width: 500px;
              padding: 0 1em;
              left: 50%;
              right: auto;
              bottom: -190px;
              transform: translateX(-50%);
            `)}

            ${mobile(() => css`
              bottom: -124px;
            `)}
          `}
        >
          <div
            css={css`
              width: 388px;

              ${tablet(() => css`
                width: 100%;
              `)}
            `}
          >
            <MainvisualConstructionCategorySearchWidget {...props} />
          </div>
        </div>
      </div>
    </div>
  );
};
